import { IControl } from "../icontrol";
import { ControlType } from "../../controltype";
import { CompareType } from '../../comparetype';

/**
 * 日期控件
 */
export class DateControl implements IControl{

    /**
     * 获取控件类型
     */
    getControlType(): ControlType {
        return ControlType.Date;
    }

    /**
     * 日期格式
     */
    //format:string;
    /**
     * 默认显示
     */
    placeholder:string;
    /**
     * 是否是展示在扩展区域内的
     */
    isExtend:boolean;

    /**是否显示label */
    showLabel:boolean;
    /**是否必填 */
    required:boolean;
    /**
     * 日期格式
     */
    format:string;
    /**
     * 搜索日期类型
     */
    compareType:CompareType;
    showType:string;
}